import type { CustomTagsFilter } from 'app/components/pages/CustomTags/CustomTags';
import type { CustomTag } from 'app/typings/customTags';
import type { SortOrder } from 'app/utils/sort';

// This function normalizes the string for comparison purposes
export const cleanString = (str: string) =>
  str
    // change diacritics to their base characters
    .normalize('NFD')
    // remove all non-alphanumeric characters
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '')
    // lowercase the string
    .toLowerCase();

type DataBySearch = {
  [key: string]: unknown;
  name: string;
};

const filterBySearch = (dataList: DataBySearch[], search?: string) => {
  if (!search) {
    return dataList;
  }

  const cleanedSearch = cleanString(search);

  return dataList.filter(({ name }) => {
    const cleanedName = cleanString(name);

    return cleanedName.includes(cleanedSearch);
  });
};

type DataByCreationDate = {
  [key: string]: unknown;
  createdAt: string;
};

const sortByCreationDate = (
  dataList: DataByCreationDate[],
  dateSorting: SortOrder
) => {
  if (dateSorting === 'none') {
    return dataList;
  }

  return dataList.sort((dataA, dataB) => {
    const valueOfA = new Date(dataA.createdAt).valueOf();
    const valueOfB = new Date(dataB.createdAt).valueOf();

    return dateSorting === 'descend'
      ? valueOfB - valueOfA
      : valueOfA - valueOfB;
  });
};

const selectByOffsetAndLimit = (
  dataList: object[],
  offset: number,
  limit: number
) => {
  return dataList.slice(offset, offset + limit);
};

export const sortAndFilterCustomTags = (
  customTags: CustomTag[],
  params: CustomTagsFilter
): CustomTag[] => {
  const { search, dateSorting, offset, limit } = params;

  const filtered = filterBySearch(customTags, search) as CustomTag[];

  const sorted = sortByCreationDate(filtered, dateSorting) as CustomTag[];

  const selected = selectByOffsetAndLimit(sorted, offset, limit) as CustomTag[];

  return selected;
};

export const formatSort = (sort: SortOrder) => {
  if (sort === 'ascend') {
    return 'ASC';
  }

  if (sort === 'descend') {
    return 'DESC';
  }

  return '';
};

export const formatSorting = (sortField: string, order: SortOrder) => {
  return `${sortField}:${formatSort(order)}`;
};
